module.exports = __webpack_public_path__ + "img/step01_bg.0f4e9c99.jpg";